export default {
  InDebt: 0, // Nợ
  Yes: 1, // Có
  BothSides: 2, // Hai bên
};
